namespace RioERP.Web.Enums {
    export enum ShippingApiStatus {
        Available = 1,
        NotAvailable = 2
    }
    Serenity.Decorators.registerEnumType(ShippingApiStatus, 'RioERP.Web.Enums.ShippingApiStatus');
}
